const firebaseConfig = {
    apiKey: "AIzaSyA5HbZlVbGq3m2g4skE8kT3eBluNoQUv-Q",
    authDomain: "assigment-router-firebase.firebaseapp.com",
    projectId: "assigment-router-firebase",
    storageBucket: "assigment-router-firebase.appspot.com",
    messagingSenderId: "483542484678",
    appId: "1:483542484678:web:386daf374396461aab79c7"
};
export default firebaseConfig;